import Radio from 'semantic-ui-react/dist/commonjs/addons/Radio';
import '@purple/semantic-ui-purple-theme/components/checkbox.css';

export default Radio;
